module.exports = __webpack_public_path__ + "img/analytical_dashboard_icon.c7e655e7.png";